/**
 * The Empy and support launchers' placement classes, in one place (#1022
 * review: each launcher spelled the docked / raised / floating logic out
 * itself, and the two had already drifted to different tour rings). The look
 * lives in shell.css (.ee-launcher, .ee-launcher--docked).
 *
 * - Floating: fixed at `floatClass` (e.g. "bottom-4 right-4"), Z_LAUNCHER.
 * - Docked: in the flow of the layout's compact header below 1280,
 *   `relative` only so the tour's z-201 can lift it over the spotlight, and
 *   no z-index otherwise (the header must not become a stacking trap).
 * - Raised (the tour spotlights it): z-201 with the ring the nav items wear.
 * - Dimmed (the tour spotlights something else): faded.
 */
export interface LauncherPlacement {
  docked: boolean;
  raised: boolean;
  dimmed?: boolean;
  /** Where a floating launcher sits; ignored when docked. */
  floatClass: string;
}

export const LAUNCHER_RAISED = 'z-[201] ring-2 ring-primary ring-offset-2 animate-pulse';

export function launcherClasses({
  docked,
  raised,
  dimmed = false,
  floatClass,
}: LauncherPlacement): string {
  const placement = docked ? 'ee-launcher--docked relative' : `fixed ${floatClass}`;
  const layer = raised ? LAUNCHER_RAISED : docked ? '' : 'z-(--ee-z-launcher)';
  return ['ee-launcher', placement, layer, dimmed ? 'opacity-30' : ''].filter(Boolean).join(' ');
}
